import { Tooltip } from 'antd';
import { FC } from 'react';
import { config } from '@utils/config';

export const DevEnvWrapper: FC<any> = ({ children }) => {
  return config.isDev || config.isStg ? (
    <Tooltip title={`This won't show on prod`}>
      <p className={'absolute right-0 top-0 m-1 flex bg-white text-xs text-black'}>{children}</p>
    </Tooltip>
  ) : null;
};
